import type { CategoryVm } from './types'

/**
 * Категории оборудования, как в 1С («Подключаемое оборудование» → типы; платформа 8.5, «Розница» 3.0.6.171 — выгружено из тестовой базы).
 * Поддерживаемые идут первыми. У остальных окно честно пишет «поддержка появится»: данные и драйверы для них ещё не делались.
 *
 * Соответствие 1С → наши категории:
 * «ККТ с передачей данных» и «Фискальные регистраторы» → «Кассы (ККТ)»; «Электронные весы» и «Весы с печатью этикеток» → «Весы»;
 * «Считыватели магнитных карт» и «Считыватели RFID» → «Считыватели карт»; «Офлайн-оборудование» в 1С устарело и не показывается.
 * Фискального накопителя как отдельного устройства в 1С нет: он стоит внутри кассы, и окно показывает его состояние вместе с кассой.
 */
export const EQUIPMENT_CATEGORIES: readonly CategoryVm[] = [
  {
    id: 'fiscal-register',
    title: 'Кассы (ККТ)',
    inOneC: 'ККТ с передачей данных, фискальные регистраторы',
    supported: true,
    note: 'Фискальный накопитель — часть кассы: срок, заполнение и обмен с оператором фискальных данных проверяются вместе с ней (см. «Неполадки»).',
  },
  { id: 'payment-terminal', title: 'Эквайринговые терминалы', inOneC: 'Эквайринговые терминалы', supported: true, note: null },
  { id: 'barcode-scanner', title: 'Сканеры штрихкода', inOneC: 'Сканеры штрихкода', supported: false, note: null },
  { id: 'label-printer', title: 'Принтеры этикеток', inOneC: 'Принтеры этикеток', supported: false, note: null },
  { id: 'receipt-printer', title: 'Принтеры чеков', inOneC: 'Принтеры чеков', supported: false, note: null },
  { id: 'customer-display', title: 'Дисплеи покупателя', inOneC: 'Дисплеи покупателя', supported: false, note: null },
  { id: 'scales', title: 'Весы', inOneC: 'Электронные весы, весы с печатью этикеток', supported: false, note: null },
  { id: 'data-collection-terminal', title: 'Терминалы сбора данных', inOneC: 'Терминалы сбора данных', supported: false, note: null },
  { id: 'card-reader', title: 'Считыватели карт', inOneC: 'Считыватели магнитных карт, считыватели RFID', supported: false, note: null },
  { id: 'recognition-device', title: 'Устройства распознавания', inOneC: 'Устройства распознавания', supported: false, note: null },
]
